export const GROUP_TYPE_CONSTANT = {
  VIEW_INTELLITICKS: {
    FORM_SAVE: "Se envia el formulario"
  },
  EMPY_STATE: {
    EMPTY_STATE_HEADER: "No hay servicios para mostrar",
    EMPTY_STATE_PARAGRAPH: "El paciente no cuenta con servicios asociados"
  },
  INTELLITICKS_REQUEST_RESPONSE: {
    INTELLITICKS_URL: "https://chat.neumomed.com",
    STATE_SESSION: "Finished"
  },
  CONFIRM_SAVE_FORM: "Formulario completado!",
  DIALOG_MESSAGES: {
    EXIT_TITLE: "Abandono de sesión",
    EXIT_TEXT:
      "La sesión iniciará de nuevo si no es finalizada ¿Está seguro de salir?"
  },
  PARENT_MESAGGES: {
    FORM_NOT_FOUND: "No se encontró el formulario",
    FORM_ERROR_FOUND: "Error consultando la información del formulario",
    CLOSE_FORM: "Se cierra el formulario!"
  }
};
